import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import './DashboardSidebar.css';
import { logout } from "../../services/auth";

const DashboardSidebar = ({ isSidebarOpen, closeSidebar }) => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout(); // Llama al servicio para cerrar sesión
      sessionStorage.removeItem("salvir_notif_attention_seen");
      navigate('/home'); // Redirige al login
    } catch (error) {
      console.error("Error al cerrar sesión:", error);
    }
  };

  return (
    <aside className={`dashboard-sidebar ${isSidebarOpen ? 'open' : ''}`}>
      <ul>
        <li>
          <NavLink
            to="/dashboard/inicio"
            className={({ isActive }) => (isActive ? 'active-link' : '')}
            onClick={closeSidebar}
          >
            Inicio
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/dashboard/citas"
            className={({ isActive }) => (isActive ? 'active-link' : '')}
            onClick={closeSidebar}
          >
            Citas
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/dashboard/historias-clinicas"
            className={({ isActive }) => (isActive ? 'active-link' : '')}
            onClick={closeSidebar}
          >
            Expedientes Clínicos
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/dashboard/recetas"
            className={({ isActive }) => (isActive ? 'active-link' : '')}
            onClick={closeSidebar}
          >
            Recetas Electrónicas
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/dashboard/finanzas"
            className={({ isActive }) => (isActive ? 'active-link' : '')}
            onClick={closeSidebar}
          >
            Indicadores
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/dashboard/configuracion"
            className={({ isActive }) => (isActive ? 'active-link' : '')}
            onClick={closeSidebar}
          >
            Configuración
          </NavLink>
        </li>
         <li>
          <NavLink
            to="/dashboard/ayuda"
            className={({ isActive }) => (isActive ? 'active-link' : '')}
            onClick={closeSidebar}
          >
            Centro de Ayuda
          </NavLink>
        </li>
        <li onClick={handleLogout} >
          Cerrar Sesión
        </li>
      </ul>
    </aside>
  );
};

export default DashboardSidebar;
